import { useEffect } from 'react';
import { useMst } from '../models/rootModel';

const extractImagesUrlStrings = (data: Record<string, any>) => {
  const result: string[] = [];

  const findStrings = (obj: Record<string, any> | string) => {
    if (typeof obj === 'string' && (obj.endsWith('.webp') || obj.endsWith('.png'))) {
      result.push(obj);
    } else if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        findStrings(obj[key]);
      }
    }
  };

  data.forEach(findStrings);
  return result;
};

// This hook find all strings in steps which ends with .webp and preload them
export const useImagesPreload = ({ isLoadingData }: { isLoadingData: boolean }) => {
  const { Step } = useMst();

  useEffect(() => {
    if (Step.steps.length > 0 && !isLoadingData) {
      const imagesUrlStrings = extractImagesUrlStrings(Step.steps);

      imagesUrlStrings.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }, [Step.steps, isLoadingData]);
};
